/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/* globals jQuery, window, document */
/* exported jQuery, window, document */

var SdxSelect = require('sdx/form/Select').default;
var zeroFill = require('lib/util/helpers').zeroFill;

(function ($, Tc, debug, SCS, ScForm, scDate) {
	'use strict';

	/**
	 * Datepicker module implementation.
	 *
	 * @author Sebastian Bartels
	 * @namespace Tc.Module
	 * @class DatePicker
	 * @extends Tc.Module
	 */
	Tc.Module.DatePicker = Tc.Module.extend({

		on: function (callback) {
			/* jslint maxstatements: 40 */
			var i, mod = this,
				now = new Date(),
				$field = $('>.date-field', mod.$ctx),
				$input = $('input[type=text]', mod.$ctx);

			// container for time field options
			mod.$select = mod.$ctx.find('select');

			// option to enable time field (drop-down)
			mod.timeEnable = mod.$ctx.data('time-enable');
			// snap appointment dates to this value (in minutes, defaults to 30)
			mod.timeInterval = parseInt(mod.$ctx.data('time-interval') || 30, 10);
			// option to show time field values as from-to ranges in drop-down
			mod.showTimeInterval = mod.$ctx.data('show-time-interval') || false;
			mod.sdx = mod.$ctx.data('sdx') || false;
			if (mod.sdx && mod.$ctx.find('.time-container select').length) {
				mod.sdxSelect = new SdxSelect(mod.$ctx.find('.time-container select')[0]);
			}
			// config for SCS.utils.date
			mod.constraints = {
				// business hours
				day: {},
				week: [
					true, // sun
					true, // mon
					true, // tue
					true, // wed
					true, // thu
					true, // fri
					true  // sat
				],
				hours: [
					scDate.toHours(mod.$ctx.data('time-from') || 8),
					scDate.toHours(mod.$ctx.data('time-to') || 17)
				],
				// date constraints
				minDate: $input.data('enable-from'),
				maxDate: $input.data('enable-until'),
				// time constraints
				time: mod.timeEnable,
				refTimeField: mod.$select,
				interval: mod.timeInterval / 60,
				includeClosingTime: !mod.showTimeInterval
			};

			// upgrade for utils.date compatible config
			// create exclude days configuration (D.M[.Y])
			var exclDateDays = $input.data('exclude-days') || [];
			for (i = 0; i < exclDateDays.length; i += 1) {
				// normalize DD.MM.YYYY to D.M.Y (remove leading zeros)
				var dayDate = exclDateDays[i].replace(/(^|\.)0+/g, '$1');
				mod.constraints.day[dayDate] = false;
			}
			// create weekday configuration (weekday in java form)
			// get a list of weekdays to skip (start from 1 = sun)
			var exclWeekDays = $input.data('no-weekdays') || [];
			for (i = 0; i < exclWeekDays.length; i += 1) {
				mod.constraints.week[exclWeekDays[i] - 1] = false;
			}

			// Working block hours in old representation
			mod.timeFrom = mod.$ctx.data('time-from') || 8;
			mod.timeTo = mod.$ctx.data('time-to') || 17;

			// calculate the length of a working day
			mod.constraints.workDuration = scDate.toHours(mod.timeTo) -
				scDate.toHours(mod.timeFrom);

			// options to skip time in work blocks
			mod.constraints.wPeriod = scDate.toHours(
				mod.timeEnable ? mod.$ctx.data('time-available-from') : 0
			);

			// create a new client validation instance
			mod.cv = ScForm.createClientValidation({
				'constraintData': mod.constraints
			});

			// get options for client validation (twice in source?)
			var clientvalidation = $field.data('clientvalidation') || {};
			// upgrade client validation constraints config
			// be used by client validation `validateDate`
			clientvalidation.constraintData = mod.constraints;

			mod.isMobile = SCS.utils.isMobilePage();
			mod.isReadOnly = $input.attr('readonly');

			mod.showCurrentDate = $input.data('show-current-date');
			mod.$timeContainer = mod.$ctx.find('.time-container');

			// not used but seem valid - keep'em around for now
			// mod.defaultTime = mod.$select.data('default-value');

			if (!mod.isReadOnly) {
				this.addDatePicker();
			}

			// overwrite old value with current date
			// but preserve browser prefilled values
			if (mod.showCurrentDate && !$input.val()) {
				// sets date in format `DD.MM.YYYY`
				$input.val(scDate.format(now));
			}

			if (mod.timeEnable) {
				// attach change handler to update time drop-down
				var proxy = $.proxy(mod.onChangeHandler, mod);
				$input.on('change', proxy).trigger('change');
				// event trigger sometimes not working?
				// mod.onSelectListener($input.val());
			}
			else {
				mod.createTimes(null);
			}

			if (mod.sdx) {
				mod.$ctx.find('.date-icon.icon').on('click focus', function () {
					$input.datepicker('show');
				});
			}

			// $input.trigger('change');
			callback();
		},

		/**
		 * Create an array of appointments for the given date/day
		 * Optionally you may pass a minimal starting date/time
		 *
		 * @method initNewModules
		 * @param {Date} date - date to create appointments for
		 * @param {Array} workBlocks - list of start/end pairs
		 * @param {Minutes|int} interval - time delta next slot
		 * @param {Date} min - minimal start date (default: now)
		 * @returns {Array} list of possible appointments
		 */
		getAppointmentTimes: function (date, config) {

			// get list of open/close pairs for the specific day
			var workBlocks = scDate.getOpeningHours(date, this.cv.constraintData);

			// maybe we have some holiday?
			if (!workBlocks) { return []; }

			// do calculations after easy checks
			var now = config.now || new Date(),
				interval = config.interval || 0.5,
				inclusive = config.includeClosingTime,
				min = scDate.getMinDate(now, config);

			// compare the day parts of the date objects
			var cmpDays = scDate.compareDays(date, min);

			// no appointments in the past
			if (cmpDays < 0) { return []; }

			// set time to zero now to make all times available
			// only needed if min and date are on the same day
			var startTime = cmpDays ?
				0 : Math.max(
					scDate.toHours(min),
					scDate.toHours(date)
				);

			// create result array
			var appointments = [];

			for (var i = 0; i < workBlocks.length; i += 2) {
				// Note: values should already be in that form
				var blockStart = scDate.toHours(workBlocks[i + 0]),
					blockStop = scDate.toHours(workBlocks[i + 1]);
				// check if we should include the closing time
				if (!inclusive) { blockStop -= interval; }
				// Now loop through this workblock by given interval
				// The last block time was deliberately left out here
				for (var t = blockStart; t <= blockStop; t += interval) {
					// add everything after the startTime
					if (t >= startTime) { appointments.push(t * 60); }
				}
			}

			// return array now
			return appointments;

		},

		// create
		createTimes: function (date) {
			var mod = this;

			// Invalid input
			if (!date) {
				mod.disableTimeField();
				return;
			}
			if (mod.sdx) {
				mod.$select = mod.$ctx.find('.time-container select');
				mod.constraints.refTimeField = mod.$select;
			}


			// allow to pass a day date string
			// we are mostly called on input values
			date = scDate.parseDateDay(date);

			// helper function to create a drop-down option
			function createOption(name, value, selected) {
				// create an option and set mandatory options
				var option = jQuery('<OPTION>').val(value).html(name);
				// optionally set the selected attribute
				if (selected) { option.attr('selected', 'selected'); }
				// return dom node
				return option[0];
			}

			// helper to convert minutes to strings
			function minutesToString(minutes) {
				return [
					zeroFill(Math.floor(minutes / 60), 2),
					zeroFill(Math.floor(minutes) % 60, 2)
				].join(':');
			}

			var interval = mod.timeInterval;
			var config = mod.cv.constraintData;

			// get array of all available appointments that day
			var times = mod.getAppointmentTimes(date, config);

			// dom node store
			var options = [];

			// create a select dropdown
			if (times && times.length) {

				// get the text to put on top of the drop-down
				var slctTxt = mod.$select.data('please-select');
				var defaultVal = mod.$select.data('default-value');

				// create a first option to enable de-selecting
				if (slctTxt) { options.push(createOption(slctTxt, '')); }

				// create options for all available times
				for (var i = 0; i < times.length; i += 1) {
					// create main label for start time
					var txt = minutesToString(times[i]);
					// maybe show a `from - to` interval
					if (mod.showTimeInterval) {
						// append the stop time to show full range with label
						txt = [txt, minutesToString(times[i] + interval)].join(' - ');
					}
					// check if entry should be selected
					var val = minutesToString(times[i]),
						selected = (val == defaultVal);
					// append the final option to our array
					options.push(createOption(txt, val, selected));
				}
			}

			// clear and append the new options
			mod.$select.empty().append(options);

			if (mod.sdx && mod.sdxSelect) {
				mod.sdxSelect.reload();
			}

			// do some magic
			if (!mod.isMobile && !mod.sdx) {
				mod.$select.resetSS();
			}

			// enable/disable time field
			if (times && times.length) {
				mod.enableTimeField();
			} else {
				mod.disableTimeField();
			}

		},

		/**
		 * Disable the time drop-down
		 *
		 * @method disableTimeField
		 * @return void
		 */
		disableTimeField: function () {
			// add disabled class from container
			this.$timeContainer.addClass('disabled');
			// add disabled property from select
			this.$select.prop('disabled', true)
				// change selection to first entry
				.prop('selectedIndex', 0)
				// trigger a change event
				// informs enhanced select
				.trigger('change');
			if (this.sdx && this.sdxSelect) {
				this.sdxSelect.disabled = true;
			}
		},

		/**
		 * Enable the time drop-down
		 *
		 * @method enableTimeField
		 * @return void
		 */
		enableTimeField: function () {
			var mod = this;
			// remove disabled property from select
			this.$select.prop('disabled', false);
			// remove disabled class from container
			this.$timeContainer.removeClass('disabled');
			if (mod.sdx && mod.sdxSelect) {
				mod.sdxSelect.reload();
				mod.sdxSelect.disabled = false;
			} else if (!mod.isMobile && !mod.sdx) {
				mod.$select.resetSS();
			}
		},

		/**
		 * Initializes the jQuery UI DatePicker with default values from module.
		 *
		 * @method addDatePicker
		 * @return void
		 */
		addDatePicker: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$input = $ctx.find('input'),
				yearTo = $input.data('year-to'),
				yearFrom = $input.data('year-from');

			yearTo = new Date(yearTo, 11, 31);
			yearFrom = new Date(yearFrom, 0, 1);
			debug.log('Tc.Module.DatePicker > addDatePicker', yearFrom, yearTo);

			// datapicker jquery plugin options
			var options = {
				firstDay: 1,
				maxDate: yearTo, // "+1m +7d",
				minDate: yearFrom, // "-1m -7d",
				yearRange: [
					yearFrom.getFullYear(),
					yearTo.getFullYear()
				].join(':'),
				dateFormat: 'dd.mm.yy',
				changeYear: $input.data('change-year'),
				changeMonth: $input.data('change-month'),
				beforeShowDay: function (date) {
					return [mod.cv.validateDay(date)];
				},
				onSelect: $.proxy(mod.onSelectListener, mod),
				buttonImage: $ctx.data('img-src'),
				buttonImageOnly: true
			};

			// mobile config
			if (mod.isMobile) {
				options.showOn = 'both';
				options.beforeShow = function (textbox, instance) {
					instance.dpDiv.css({
						marginTop: 10 + 'px'
					});
				};
				// Note: why only mobile?
				$input.data('role', 'date');
			}
			// desktop config
			else {
				options.showOn = 'button';
				options.beforeShow = function (textbox, instance) {
					instance.dpDiv.css({
						marginTop: 10 + 'px',
						marginLeft: textbox.offsetWidth - 155 + 'px'
					});
					if ($('.modSubtotal.sdxStyle').length) {
						instance.dpDiv.addClass('subTotalSpacer');
					}
				};
			}
			// instantiate jquery plugin
			$input.datepicker(options);
			if (mod.sdx) {
				mod.$ctx.find('.ui-datepicker-trigger').remove();
			}
		},

		onChangeHandler: function (event) {
			var element = $(event.currentTarget);
			this.onSelectListener(element.val());
		},

		onSelectListener: function (date) {
			var mod = this;
			if (!mod.timeEnable) {
				return;
			}
			if (!mod.cv.validate(date)) {
				mod.disableTimeField();
				return;
			}
			// update drop-down
			mod.createTimes(date);
		}

	});
})(window.Tc.$, window.Tc, window.debug, window.SCS = window.SCS || {}, window.ScForm = window.ScForm || {}, window.SCS.utils.date);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.DatePicker.js
// module id = 272
// module chunks = 0